export const environment = {
    useMocks: {
        vehicles: false,
        oem: false,
    },
    production: false,

    url: 'https://apiqa.digitaltouch-point.com/api',
};
